/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Directive, TemplateRef } from "@angular/core";
var WizardPageTitleDirective = (function () {
    function WizardPageTitleDirective(pageTitleTemplateRef) {
        this.pageTitleTemplateRef = pageTitleTemplateRef;
    }
    return WizardPageTitleDirective;
}());
export { WizardPageTitleDirective };
WizardPageTitleDirective.decorators = [
    { type: Directive, args: [{
                selector: "[clrPageTitle]"
            },] },
];
/** @nocollapse */
WizardPageTitleDirective.ctorParameters = function () { return [
    { type: TemplateRef, },
]; };
//# sourceMappingURL=page-title.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/wizard/directives/page-title.js
// module id = 100
// module chunks = 4